import { safeDateFormat, safeDateRangeFormat } from '@costar/react-datepicker';

function resolveAfterText(locale, dateFormat, resolveLocaleString) {
  return function (isoDate) {
    var localFormattedDate = safeDateFormat(new Date(isoDate), {
      locale: locale,
      dateFormat: dateFormat
    });
    return resolveLocaleString ? resolveLocaleString({
      isoDate: isoDate,
      localFormattedDate: localFormattedDate
    }) : "After ".concat(localFormattedDate);
  };
}
function resolveBeforeText(locale, dateFormat, resolveLocaleString) {
  return function (isoDate) {
    var localFormattedDate = safeDateFormat(new Date(isoDate), {
      locale: locale,
      dateFormat: dateFormat
    });
    return resolveLocaleString ? resolveLocaleString({
      isoDate: isoDate,
      localFormattedDate: localFormattedDate
    }) : "Before ".concat(safeDateFormat(new Date(isoDate), {
      locale: locale,
      dateFormat: dateFormat
    }));
  };
}
function resolveDateRange(locale, dateFormat, resolveLocaleString) {
  return function (isoMinDate, isoMaxDate) {
    return resolveLocaleString ? resolveLocaleString(isoMinDate, isoMaxDate) : safeDateRangeFormat(new Date(isoMinDate), new Date(isoMaxDate), {
      locale: locale,
      dateFormat: dateFormat
    });
  };
}
function defaultResolveDisplayText (resolveDateRange, resolveAfterText, resolveBeforeText) {
  return function (selectedDatesISOString) {
    return selectedDatesISOString && (selectedDatesISOString.minValue || selectedDatesISOString.maxValue) ? selectedDatesISOString.minValue && selectedDatesISOString.maxValue ? resolveDateRange(selectedDatesISOString.minValue, selectedDatesISOString.maxValue) : selectedDatesISOString.minValue ? resolveAfterText(selectedDatesISOString.minValue) : selectedDatesISOString.maxValue ? resolveBeforeText(selectedDatesISOString.maxValue) : undefined : undefined;
  };
}

export default defaultResolveDisplayText;
export { resolveAfterText, resolveBeforeText, resolveDateRange };
//# sourceMappingURL=resolve-display-text.esm.js.map
